import React, { useState } from 'react'
import { Container, Row, Col, Card, CardBody, Form, FormGroup, Label, Input, Button, Alert } from 'reactstrap'
import { Breadcrumbs } from '../../AbstractElements'
import HeaderCard from '../Common/Component/HeaderCard'
import { useNavigate } from 'react-router-dom'
import { createUser } from '../../lib/auth'
import { addData } from '../../lib/profiles'
import { useLayout } from '../../Hooks/useLayout'
import { useRoleBasedUrl } from '../../Hooks/useRoleBasedUrl'

const AdminInstructorCreate = () => {
	const [email, setEmail] = useState('')
	const [validationError, setValidationError] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [loading, setLoading] = useState(false)

	const navigate = useNavigate()
	const layout = useLayout()
	const role = useRoleBasedUrl()

	const handleSubmit = async (e) => {
		e.preventDefault()
		setLoading(true)
		setValidationError(false)

		try {
			const { data, error } = await createUser(email, '12345', 'Instructor')

			if (data.user) {
				await addData({
					id: data.user.id,
					email: email,
					role: 'Instructor'
				})

				navigate(`${process.env.PUBLIC_URL}/${role}/instructors/edit/${data.user.id}/Add/${layout}`)
			}

			if (error) {
				setValidationError(true)
				setErrorMessage('Error: ' + error.message)
			}
		} catch (err) {
			setValidationError(true)
			setErrorMessage('An error occurred while creating the instructor')
		} finally {
			setLoading(false)
		}
	}

	return (
		<>
			<Breadcrumbs parent="Instructor Management" title="Create Instructor" mainTitle="Create New Instructor" />
			<Container fluid={true}>
				<Row>
					<Col sm="12">
						<Card>
							<HeaderCard title="Create New Instructor" subTitle="Add a new instructor to the system" />
							<CardBody>
								<Form onSubmit={handleSubmit}>
									<Row>
										<Col md="6">
											<FormGroup>
												<Label for="email">Email Address</Label>
												<Input
													id="email"
													type="email"
													value={email}
													onChange={(e) => setEmail(e.target.value)}
													placeholder="Enter instructor's email address"
													required
													disabled={loading}
												/>
											</FormGroup>
										</Col>
									</Row>

									{validationError && (
										<Alert color="danger" className="mt-3">
											{errorMessage}
										</Alert>
									)}

									<div className="d-flex justify-content-between mt-4">
										<Button type="submit" color="primary" disabled={loading || !email}>
											{loading ? 'Creating...' : 'Next Step >>'}
										</Button>
										<Button type="button" color="secondary" onClick={() => navigate(-1)} disabled={loading}>
											Cancel
										</Button>
									</div>
								</Form>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</Container>
		</>
	)
}

export { AdminInstructorCreate }
